import { createFileRoute } from "@tanstack/react-router";
import { LoginLayout } from "~/routes/_login/route";
import { ResetPasswordPage } from "~/routes/_login/reset-password";

type ResetPasswordSearch = {
  token: string;
  error?: string;
};

export const Route = createFileRoute("/__main/$locale/reset-password")({
  validateSearch: (search: Record<string, unknown>): ResetPasswordSearch => {
    return {
      token: (search.token as string) || "",
      error: typeof search.error === "string" ? search.error : undefined,
    };
  },
  component: function LocaleResetPassword() {
    return (
      <LoginLayout>
        <ResetPasswordPage />
      </LoginLayout>
    );
  },
});
